import { render, staticRenderFns } from "./TreePermissionCheckbox.vue?vue&type=template&id=2c657dc8&scoped=true&"
import script from "./TreePermissionCheckbox.vue?vue&type=script&lang=js&"
export * from "./TreePermissionCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./TreePermissionCheckbox.vue?vue&type=style&index=0&id=2c657dc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c657dc8",
  null
  
)

export default component.exports